import { render, staticRenderFns } from "./test-canvas.vue?vue&type=template&id=7da65de9&scoped=true&"
import script from "./test-canvas.vue?vue&type=script&lang=js&"
export * from "./test-canvas.vue?vue&type=script&lang=js&"
import style0 from "./test-canvas.vue?vue&type=style&index=0&id=7da65de9&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da65de9",
  null
  
)

export default component.exports